import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import { Link } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'

const MainNav = () => (
  <>
    <Navbar bg='primary' variant='dark'>
      <Link to='/'>
        <img src='https://static.da-io.net/images/da-logo.png' alt='DA logo' height='38' />
      </Link>
      <LinkContainer to='/'>
        <Navbar.Brand>
          Staff Directory
        </Navbar.Brand>
      </LinkContainer>
    </Navbar>
    <Nav className='sub-nav'>
      <LinkContainer to='/'><Nav.Link>Home</Nav.Link></LinkContainer>
      <Nav.Link href='https://login.voteda.org/logout'>Logout</Nav.Link>
    </Nav>
  </>
)

export default MainNav
